import { intl } from 'i18n/I18nProvider';
import type { Middleware } from '@reduxjs/toolkit';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { RegisterTransactionResponse } from '../fmsrService/fmsr.types';

type Error = {
  message: string;
  error: string;
  statusCode: number;
};

export type PayloadError = {
  code: number;
  message: RegisterTransactionResponse | Error | string;
};

const defaultError = intl.formatMessage({ id: 'error.default' });

// eslint-disable-next-line sonarjs/cognitive-complexity
export const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const payload = action.payload as PayloadError;
    if (
      typeof payload.message === 'object' &&
      'code' in payload.message &&
      'localizedText' in payload.message
    ) {
      const errorMessage = payload.message.localizedText || '';
      errorMessage && toast.error(errorMessage);
    } else if (typeof payload.message !== 'string' && 'message' in payload.message) {
      toast.error(payload.message.message);
    } else if (typeof payload.message === 'string' && 'message' in payload) {
      const error = payload.message.length > 200
        ? `${payload.message.substring(0, 200)}...` 
        : payload.message;
      toast.error(error);
    } else {
      toast(defaultError, {
        icon: '⚠',
      });
    }
  }

  return next(action);
};
